<div class="pay-with-card">
  @if (loadingPayForm$ | async) {
    <div class="loading-indicator">
      <i class="ficon-spin ficon-spinner ficon-2x"></i>
    </div>
  }

  <div id="braintree-v3-pay-form" [hidden]="loadingPayForm$ | async"></div>

  @if (payFormError$ | async) {
    <p class="small-font error-text"
      translate="payment-panel-braintree-error_error-with-pay-form-message">
    </p>
  }
</div>
